export default __webpack_public_path__ + "img/heating.type.03.asset.0e5375a4.jpg";